module.exports = __webpack_public_path__ + "img/level3addon_mining_hands_mask.df2bcd96.png";